// extracted by mini-css-extract-plugin
export default {"arrow":"BFZeroPriceChangeIndicator_arrow__K72zF","arrow__down":"BFZeroPriceChangeIndicator_arrow__down__Rs1Lo","arrow__up":"BFZeroPriceChangeIndicator_arrow__up__40dR5"};